module.exports = "/assets/f6398176e3beb620cdf8afde58f27d57.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/XC.png
// module id = 1991
// module chunks = 0